ACC.blockconseils = {

	_autoload: [
		"buildTab",
	],

	buildTab: function () {

		$blocConseils = $(".myaccount-bloc-conseils");
		$wrapper = $("<div class='myaccount-bloc-conseils-content'></div>");

		function createTab(){

			if($blocConseils.find("h2").length > 0 && $blocConseils.find(".myaccount-bloc-conseils-content").length === 0){
				//  console.log("ok");
				$blocConseils.contents().appendTo($wrapper);
				$wrapper.appendTo($blocConseils);
				$wrapper.find("h2").insertBefore($wrapper);
				$blocConseils.on("click","h2",function(e){
					e.preventDefault();

						$content = $(this).parent().find(".myaccount-bloc-conseils-content");
						$(this).parent().toggleClass("folded");

						if($(this).parent().hasClass("folded")){
							$content.animate({
								scrollTop : $content.height(),
							}, {queue: false, duration: 300});
						}
				});
			}
		}

		$(window).on('load resize', function(){
			if($(window).width() < 640){
				createTab();
			}
		});
	}
};
